/* 获取camera中心点坐标 */
function getCameraCenterPosition () {
  const viewer = self.viewer
  const result = viewer.camera.pickEllipsoid(
    new Cesium.Cartesian2(
      viewer.canvas.clientWidth / 2,
      viewer.canvas.clientHeight / 2
    )
  )
  const curPosition = Cesium.Ellipsoid.WGS84.cartesianToCartographic(result)
  const lon = (curPosition.longitude * 180) / Math.PI
  const lat = (curPosition.latitude * 180) / Math.PI
  const height = getHeight(viewer)
  return {
    lon: lon,
    lat: lat,
    height: height
  }
}

function getCameraCenterPosition1 () {
  // position
  const viewer = self.viewer
  const result = viewer.camera.pickEllipsoid(
    new Cesium.Cartesian2(
      viewer.canvas.clientWidth / 2,
      viewer.canvas.clientHeight / 2
    )
  )
  return result
}

function getCameraCurrentExtent () {
  //
  const viewer = self.viewer
  // 范围对象
  const extent = {}

  // 得到当前三维场景
  const scene = viewer.scene

  // 得到当前三维场景的椭球体
  const ellipsoid = scene.globe.ellipsoid
  const canvas = scene.canvas

  // canvas左上角
  const car3lt = viewer.camera.pickEllipsoid(
    new Cesium.Cartesian2(0, 0),
    ellipsoid
  )

  // canvas右下角
  const car3rb = viewer.camera.pickEllipsoid(
    new Cesium.Cartesian2(canvas.width, canvas.height),
    ellipsoid
  )

  // 当canvas左上角和右下角全部在椭球体上
  if (car3lt && car3rb) {
    const cartolt = ellipsoid.cartesianToCartographic(car3lt)
    const cartorb = ellipsoid.cartesianToCartographic(car3rb)
    extent.xmin = Cesium.Math.toDegrees(cartolt.longitude)
    extent.ymax = Cesium.Math.toDegrees(cartolt.latitude)
    extent.xmax = Cesium.Math.toDegrees(cartorb.longitude)
    extent.ymin = Cesium.Math.toDegrees(cartorb.latitude)
  } else if (!car3lt && car3rb) {
    // 当canvas左上角不在但右下角在椭球体上
    let car3lt2 = null
    let yIndex = 0
    do {
      // 这里每次10像素递加，一是10像素相差不大，二是为了提高程序运行效率
      yIndex <= canvas.height ? (yIndex += 10) : canvas.height
      car3lt2 = viewer.camera.pickEllipsoid(new Cesium.Cartesian2(0, yIndex), ellipsoid)
    } while (!car3lt2)
    const cartolt2 = ellipsoid.cartesianToCartographic(car3lt2)
    const cartorb2 = ellipsoid.cartesianToCartographic(car3rb)
    extent.xmin = Cesium.Math.toDegrees(cartolt2.longitude)
    extent.ymax = Cesium.Math.toDegrees(cartolt2.latitude)
    extent.xmax = Cesium.Math.toDegrees(cartorb2.longitude)
    extent.ymin = Cesium.Math.toDegrees(cartorb2.latitude)
  }

  // 获取高度
  extent.height = Math.ceil(viewer.camera.positionCartographic.height)
  return extent
}

/* 获取camera高度  */
function getHeight (viewer) {
  if (viewer) {
    const scene = viewer.scene
    const ellipsoid = scene.globe.ellipsoid
    const cartesian = ellipsoid.cartesianToCartographic(viewer.camera.position)
    const height = cartesian.height
    return height
  }
}

function getMoveEndPosition (viewer) {
  const _camera = viewer.scene.camera
  // 相机移动事件
  _camera.moveEnd.addEventListener(function () {
    const ellipsoid = viewer.scene.globe.ellipsoid
    const result = viewer.camera.pickEllipsoid(new Cesium.Cartesian2(viewer.canvas.clientWidth / 2, viewer.canvas
      .clientHeight / 2))
    const cartesian = Cesium.Ellipsoid.WGS84.cartesianToCartographic(result)
    const cartographic = ellipsoid.cartesianToCartographic(cartesian)
    const lat = Cesium.Math.toDegrees(cartographic.latitude)
    const lng = Cesium.Math.toDegrees(cartographic.longitude)
    const height = viewer.camera.positionCartographic.height.toFixed(0)
    const heading = Cesium.Math.toDegrees(_camera.heading).toFixed(2)
    const pitch = Cesium.Math.toDegrees(_camera.pitch).toFixed(2)
    // TODO PubSub 部分调用
    return { lat, lng, height, heading, pitch }
  })
}

export {
  getCameraCenterPosition,
  getCameraCurrentExtent,
  getMoveEndPosition
}
